import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ObservableInput} from 'ngx-observable-input';
import {Observable} from 'rxjs';
import {Collar, Pet} from '../public-clients';
import {Collar as PrivateCollar, DevicesClient, GetCollars} from "../../../shared";
import {MatDialog} from "@angular/material/dialog";
import {distinctUntilChanged, map, switchMap} from "rxjs/operators";

@Component({
  selector: 'app-settings-card',
  templateUrl: './settings-card.component.html',
  styleUrls: ['./settings-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SettingsCardComponent {
  @ObservableInput() @Input('collar') collar$: Observable<Collar>;
  @ObservableInput() @Input('pet') pet$: Observable<Pet>;
  private$: Observable<PrivateCollar>;

  constructor(private devicesClient: DevicesClient) {
    this.private$ = this.collar$.pipe(
      map(collar => collar.id),
      distinctUntilChanged(),
      switchMap(id => this.devicesClient.getCollars(new GetCollars({keywords: id}))),
      map(paged => paged.items[0])
    )
  }

  encode(petId: string): string {
    return encodeURI(`EventId = 7235 and PetId = '${petId}'`);
  }
}
